import { MenuAlkivi } from './menu.js';
import { Gallery } from './gallery.js';
import { Animations } from './animations.js';
import { Tabs } from './tabs.js';
import { Home } from './home.js';
import { TextLoop } from './text-loop.js';
import { ParallaxEffect } from './parallax-effect.js';
import { PageMenu } from './page-menu.js';
import { ModalDialog } from './modal-dialog.js';



(function() {
  "use strict";



  class Main {
    constructor() {

      const _menu = new MenuAlkivi();
      _menu.init();

      const _gallery = new Gallery();
      _gallery.init();

      const _animations = new Animations();
      _animations.init();

      const _tabs = new Tabs();
      _tabs.init();

      const _home = new Home();
      _home.init();

      const _textLoop = new TextLoop();
      _textLoop.init();

      const _parallaxEffect = new ParallaxEffect();
      _parallaxEffect.init();

      const _pageMenu = new PageMenu();
      _pageMenu.init();

      const _modalDialog = new ModalDialog();
      _modalDialog.init();

      let _self = this;
      $(".js-modal-btn").each(function(i,el){
        // console.log('js-modal-btn', el, $(el).attr('data-video-id'), $(el).attr('href'));
        if(typeof $(el).attr('data-video-id') == 'undefined' ||  $(el).attr('data-video-id') == '') {
          $(el).attr('data-video-id', _self.mkwvs_get_video_url_id($(el).attr('href')));
        }
        $(el).modalVideo({ channel: /\D/.test( $(el).attr('data-video-id') ) ? 'youtube' : 'vimeo' });
      });

      _self.setVw();
      window.addEventListener('resize', _self.setVw);

    }

    mkwvs_get_video_url_id(url){
    	if(url.indexOf('youtu.be') > 0 || url.indexOf('youtube') > 0) {
    		var regex = /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i;
    		var found = url.match(regex);
    		return found[1];
    	} else if(url.indexOf('vimeo') > 0) {
    		var videoURL = new URL(url);
    		return videoURL.pathname.substring(1);
    	} else {
    		return 'unknown';
    	}
    }

    setVw() {
      let vw = document.documentElement.clientWidth / 100;
      document.documentElement.style.setProperty('--vw', `${vw}px`);
    }


  }

  const _main = new Main();


}());
